import staffers from "./staffers";
import chats from "./chats";
import groups from "./groups";
import warehouseActs from "./warehouse-acts";
import { serialize } from "@/utils";

export default {
  namespaced: true,
  state: {
    path: "aljabr/telegram-api/teacher",
  },
  modules: {
    chats,
    staffers,
    groups,
    warehouseActs,
  },
  actions: {
    "star-history": ({ dispatch, state, rootState }, options) => {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/star-history?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    "add-star": ({ dispatch, state, rootState }, data) => {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/add-star`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
  },
};
